import { isInWebView } from './isInWebView';

type EventName =
  | 'sign_up'
  | 'application_first_main'
  | 'loan_first_main'
  | 'download_pdf';

export const postMessageToApp = (name: EventName, params = {}) => {
  if (isInWebView()) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        name,
        params,
      }),
    );
  }
};
